export const environment = {
  production: false,
  stage: 'test',
  apiUrl: 'https://api.test.farmfieldplanner.app',
};
